<template>
<div class="container main">
  <div class="row">
    <div class="col-md-12">
      <div class="logo">
        <img src="/static/img/logo.png">
                </div>
      </div>
      <div class="col-md-12">
        <div class="login_form">
          <form>
            <div class="offset-md-3 col-md-6">
              <msg-component :type_msg="general_msg_type" :text="general_msg_text"></msg-component>
            </div>
            <div class="col-md-12">
              <input class="mail" v-bind:class="{fail: mail_fail}" v-model="email" 
              v-on:keyup.enter="$refs.password.focus()"
              placeholder="Электронная почта" type="text">
                        </div>
              <div class="offset-md-3 col-md-6 after-input-msg">
                <p v-if="email_msg_text">{{email_msg_text}}</p>
              </div>
              <div class="col-md-12">
                <input class="pwd" v-bind:class="{fail: pwd_fail}" v-model="password" 
                v-on:keyup.enter="user_login"
                ref="password"
                placeholder="Пароль" type="password">
            </div>
                <div class="offset-md-3 col-md-6 after-input-msg">
                  <p v-if="password_msg_text">{{password_msg_text}}</p>
                </div>
          </form>
          <div class="col-md-12">
            <button class="enter" v-on:click="user_login">Войти</button>
          </div>
        </div>
      </div>
      <div class="after-login-form-buttons">
        <div class="col-md-12">
          <router-link :to="{ name: 'recovery-password'}" class="pwd">
            Забыли пароль?
          </router-link>
        </div>
        <div class="col-md-12">
          <router-link :to="{ name: 'registration'}" class="reg">
            Регистрация
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config.js'
import auth from '@/auth.js'
import msg from './elements/msg.vue'

export default {
  name: 'authBlock',
  data() {
    return {
      email: '',
      password: '',
      mail_fail: false,
      general_msg: msg,
      pwd_fail: false,
      general_msg_type: 'hidden',
      general_msg_text: '',
      email_msg_type: 'hidden',
      email_msg_text: '',
      password_msg_type: 'hidden',
      password_msg_text: ''
    }
  },
  components: {
    'msg-component': msg
  },
  methods: {
    user_login: function (event) {
      this.general_msg_type = 'hidden'
      this.email_msg_type = 'hidden'
      this.password_msg_type = 'hidden'
      this.pwd_fail = false
      this.mail_fail = false
      this.email_msg_text = ''
      this.password_msg_text = ''
      auth.login(this.email, this.password, (loggedIn) => {
        if (!loggedIn.status) {
          if (!!loggedIn.data.exceptions) {
            if (loggedIn.data.exceptions.length > 0) {
              this.general_msg_type = 'alert'
              this.general_msg_text = loggedIn.data.exceptions
            }
          }
          if (!!loggedIn.data.fields_exceptions.email) {
            this.mail_fail = true
            this.email_msg_type = 'alert'
            this.email_msg_text = loggedIn.data.fields_exceptions.email
          }
          if (!!loggedIn.data.fields_exceptions.password) {
            this.pwd_fail = true
            this.password_msg_type = 'alert'
            this.password_msg_text = loggedIn.data.fields_exceptions.password
          }
        } else {
          this.$router.replace(this.$route.query.redirect || '/groups-list')
        }
      })
    }
  }
}
</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/auth.vue